import React from "react";
import CreateBot from "../../botForm";
import CreateStepper from "../../createBotStepper/index";
import styles from "../../../styles/pages/createBotFinal.module.scss";
import axios from "axios";
import botStyles from "../../../styles/pages/createBot.module.scss";
import { useRouter } from "next/router";
import { firstBotCreateAction } from "../../../redux/createBot/actions";
import { useDispatch, connect } from "react-redux";
import endpoint from "../../../utility/endpoints";
import { allBotStates } from "../../../data/createBotForm";
import SuccessModal from "../../dynamicSuccessModal";
import BotDetailPage from "../../botDetailEndUser";
import BusinessownerModalComp from "../../../pages/successModal";
import {sessionTimeOutCheck,checkExpiry} from "../../../redux/global/actions"
import { bindActionCreators } from "redux";
import Loader from "../../Loader"

import { product, family, domain } from "./gdt_data";
import endpoints from "../../../utility/endpoints";


const index = (props) => {
  //console.log("props dekh",props)
  const [successModal, setSuccessModal] = React.useState(false);
  const [message, setMessage] = React.useState("Bot created successfully!");
  const [loading, setloading ] = React.useState(false);
  const firstPage = props.data[0].component.content.field_new_bot_details[0];
  const secondPage = props.data[0].component.content.field_new_bot_details[1];
  const thirdPage = props.data[0].component.content.field_new_bot_details[2];
  const fourthPage = props.data[0].component.content.field_new_bot_details[3];

  const [renderFirstBot, setRenderFirstBot] = React.useState(null);

  const router = useRouter();
  const dispatch = useDispatch();

  const isDevEnvironment = endpoints.environment === "dev" ? true : false;

  const productData = product;
  const familyData = family;
  const domainData = domain;

  const leadPlatformData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[3]
    : props.globalData.lead_platform_main_component[1];
  const areaData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[4]
    : props.globalData.lead_platform_main_component[4];
  const subAreaData = isDevEnvironment
    ? props.globalData.lead_platform_main_component[5]
    : props.globalData.lead_platform_main_component[3];

  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const countryData = props.globalData.cluster_main_component[2];

  React.useEffect(() => {
    firstPage.field_bot_form_steps.splice(1, 0, productData);
    firstPage.field_bot_form_steps.splice(1, 0, familyData);
    firstPage.field_bot_form_steps.splice(1, 0, domainData);
    firstPage.field_bot_form_steps.splice(4, 0, subAreaData);
    firstPage.field_bot_form_steps.splice(4, 0, areaData);
    firstPage.field_bot_form_steps.splice(4, 0, leadPlatformData);
    firstPage.field_bot_form_steps.splice(7, 0, countryData);
    firstPage.field_bot_form_steps.splice(7, 0, mcoData);
    firstPage.field_bot_form_steps.splice(7, 0, clusterData);
    setRenderFirstBot(true);
  }, []);

  const useMe = {
    1: false,
    2: false,
    3: false,
    4: false,
  };

  const [botPages, setBotPages] = React.useState({
    1: true,
    2: false,
    3: false,
    4: false,
  });

  const [pageNumber, setPageNumber] = React.useState(1);
  const [done, setDone] = React.useState(false);
  const [showPreview, setShowPreview] = React.useState(false);
  const [newlyCreatedBotID, setNewlyCreatedBotID] = React.useState("");
  const [businessOwnerModal, setBusinessOwnerModal] = React.useState(false);

  const nextBot = async (pageNum) => {
    setBotPages({
      ...useMe,
      [pageNum]: true,
    });
    setPageNumber(pageNum);
    window.scrollTo(0, 0);
  };

  const saveInfoToRedux = async (state, pageNum) => {
    if (pageNum == 1) {
      if (!state.documentFolderName){
        //console.log(localStorage.getItem("auth"), "authThatI")
        let auth =  JSON.parse(localStorage.getItem("auth")).data;
        state.documentFolderName = Date.now()
       axios({
          method : "post",
          url: `${endpoint.baseUrl}/bot/addFolderName`,
          data: { folderName : state.documentFolderName},
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((res) => {
          //console.log(res)
        })

      }
    }
    // need to be removed
    // if(pageNum == 2){
    //   state.sopDocument="8456191154484498-img_1645186514_sopDocument.png"
    // }
    dispatch(firstBotCreateAction(state));
  };

  const allDone = () => {
    setShowPreview(true);
    window.scrollTo(0,0)
  };

  const backToEdit = () => {
    setShowPreview(false);
    setBotPages({ ...useMe, 4: true });
  };

  const createTheBot = () => {
    setDone(true);
  };

  React.useEffect( () => {

    async function doIt() {

    debugger;
    if (done == true) {
      setloading(true)
      if (props.botFormState.landscapeApproval == "Yes") {
        props.botFormState.landscapeApproval = true;
      } else {
        props.botFormState.landscapeApproval = false;
      }

      if (props.botFormState.infosecApproval == "Yes") {
        props.botFormState.infosecApproval = true;
      } else {
        props.botFormState.infosecApproval = false;
      }

      if (props.botFormState.requestType == "New Request") {
        props.botFormState.parentBotID = "";
      }

      let countryString = "";
      for (let i in props.botFormState.country) {
        
        if (i <props.botFormState.country.length-1    && props.botFormState.country.length>1) {
        countryString = countryString + props.botFormState.country[i] + ",";
        }
        else {
          countryString = countryString+props.botFormState.country[i] 
        }
      }

      props.botFormState.country = countryString;

      //technology
        let technologyString = "";
        for (let i in props.botFormState.technology) {
          if (
            i < props.botFormState.technology.length - 1 &&
            props.botFormState.technology.length > 1
          ) {
            technologyString =
              technologyString + props.botFormState.technology[i] + ",";
          } else {
            technologyString =
              technologyString + props.botFormState.technology[i];
          }
        }

        props.botFormState.technology = technologyString;

      let mcoString = "";
      for (let i in props.botFormState.mco) {
        
        if (i <props.botFormState.mco.length-1    && props.botFormState.mco.length>1) {
          mcoString = mcoString + props.botFormState.mco[i] + ",";
        }
        else {
          mcoString = mcoString+props.botFormState.mco[i] 
        }
      }

      props.botFormState.mco = mcoString;

      let auth = JSON.parse(localStorage.getItem("auth")).data;
      delete props.botFormState.uploadDocumentsState;

      let createBotDataToSend = {
        UserEmail: auth.email,
        // ...allBotStates,
        ...props.botFormState,
       review: {
            status: false,
            comment: "Review Pending",
          },
      };

      createBotDataToSend.createdBy = auth.name;
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        await axios({
          method : "post",
          url: `${endpoint.baseUrl}/bot/getBotCount`,
          data: {
            landscapeId:null,
            parentBotID:"",
            botType:"master"
        },
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        }).then((res) => {
          //console.log(res)
          let landscapeId='';
          const landscape=createBotDataToSend.landscape
          if(landscape=='Global'){landscapeId='0';}
          if(landscape=='Fusion'){landscapeId='1';}
          if(landscape=='Sirius'){landscapeId='2';}
          if(landscape=='Cordillera'){landscapeId='3';}
          if(landscape=='U2K2'){landscapeId='4';}
          const masterbotId=parseInt(res.data.data.masterBotID)+1;
          createBotDataToSend.masterBotID=masterbotId;
          createBotDataToSend.botExternalId=masterbotId
          createBotDataToSend.botType="master"
          createBotDataToSend.landscapeId=landscapeId
          
        })
      
      axios({
        method: "post",
        url: `${endpoint.baseUrl}/bot/createBot`,
        data: createBotDataToSend,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((resp) => {
              if (resp.data.code == 200) {
                //console.log(resp.data.data);
                setNewlyCreatedBotID(resp.data.data.botExternalId);
                setloading(false);
                setSuccessModal(true);
              } else if (resp.data.code == 403) {
                setloading(false);
                localStorage.removeItem("auth");
                sessionStorage.clear();
                props.sessionTimeOutCheck(true);
              } else if (resp.data.code == 500) {
                console.log("Error", resp.data.data);
                setloading(false);
                setSuccessModal(false);
              } else {
                console.log("Logs", resp.data);
                setloading(false);
              }
            })
            .catch((err) => {
              console.log("Error", err);
              setloading(false);
            });
    }
    else {
      setloading(false)
      props.sessionTimeOutCheck(true)
    }
    }
  }
  doIt()
  }, [done]);

  return showPreview ? (
    <>
    {loading ? <Loader /> : null}
      
      <BotDetailPage
        myBot={props.botFormState}
        type="previewPage"
        backToEdit={backToEdit}
        createTheBot={createTheBot}
      />
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          parent={"createBot"}
          data={props.data[1].component.content}
          botID={newlyCreatedBotID}
        />
      ) : null}
    </>
  ) : (
    <div className={styles.mainContainer}>
      <div className={styles.stepperContainer}>
        {successModal ? (
          <SuccessModal
            setSuccessModal={setSuccessModal}
            parent={"createBot"}
            data={props.data[1].component.content}
            botID={newlyCreatedBotID}
          />
        ) : null}

        {businessOwnerModal ? (
          <BusinessownerModalComp
            setSuccessModal={setBusinessOwnerModal}
            title={"User Access Mapping"}
            message={"Business owner already exist with another user type"}
            // setMessage={setMessage}
            fail={true}
            // setFail={setFail}
          />
        ) : null}


        
        <CreateStepper pageNumber={pageNumber} editBot={false} />
      </div>
      {botPages[1] == true && renderFirstBot ? (
        <>
          <div className={botStyles.botContainer}>
            <CreateBot
              nextBot={nextBot}
              data={firstPage.field_bot_form_steps}
              pageNum={1}
              saveInfoToRedux={saveInfoToRedux}
              savedState={props.botFormState}
              globalData={props.globalData}
              setBusinessOwnerModal={setBusinessOwnerModal}
            />
          </div>
        </>
      ) : null}
      {botPages[2] == true ? (
        <CreateBot
          nextBot={nextBot}
          data={secondPage.field_bot_form_steps}
          pageNum={2}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.botFormState}
        />
      ) : null}
      {botPages[3] == true ? (
        <CreateBot
          nextBot={nextBot}
          data={thirdPage.field_bot_form_steps}
          pageNum={3}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.botFormState}
        />
      ) : null}
      {botPages[4] == true ? (
        <CreateBot
          allDone={allDone}
          nextBot={nextBot}
          data={fourthPage.field_bot_form_steps}
          pageNum={4}
          saveInfoToRedux={saveInfoToRedux}
          savedState={props.botFormState}
        />
      ) : null}
    </div>
  );
};


const mapStateToProps = (state) => {
  //console.log("state",state)
  return {
    botFormState: state.createBot,
    currentBot: state.storeBot.currentBot,
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

